import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { AI_GATEWAY } from '@workheld/workheld-shared-lib';
import { buildWhAiStyleConfig } from './wh-ai-chat.styles';

export const AI_ENDPOINT = `${environment.apiUrl + AI_GATEWAY}/chats/stream`;

export function createWhAiChatConfig(translate: TranslateService) {
  const styleConfig = buildWhAiStyleConfig(translate);

  return {
    textInput: styleConfig.textInput,
    messageStyles: styleConfig.messageStyles,
    inputAreaStyle: styleConfig.inputAreaStyle,
    focusMode: styleConfig.focusMode,
    auxiliaryStyle: styleConfig.auxiliaryStyle,
    submitButtonStyles: styleConfig.submitButtonStyles,
  };
}
